import { createSlotRecipe } from './runtime';

const collapsibleConfig = {"name":"collapsible","slots":["root","trigger","content"]}

export const collapsible = /* @__PURE__ */ createSlotRecipe(collapsibleConfig)